export const colours = {
	gray: {
		50: "#f7f7f7",
		100: "#f0f0f0",
		200: "#e0e0e0",
		300: "#d1d1d1",
		400: "#b3b3b3",
		500: "#969696",
		600: "#737373",
		700: "#525252",
		800: "#333333",
		900: "#262626",
	},
	neutrals: {
		50: "#f4f5f7",
		100: "#C1C7D0",
		300: "#5e6c84",
	},
	blue: {
		500: "#f4f6ff",
		600: "#110a4e",
	},
	red: {
		500: "#AD1F1F",
	},
	blueGray: {
		300: "#8c94a1",
		400: "#6B778C",
		600: "#54698c",
	},
	navy: {
		700: "#505f79",
		800: "#42526E",
	},
	text: {
		body: "#051839",
		warning: "#84560B",
	},
	danger: {
		icon: "#CB4655",
		background: {
			strong: "#CB4655",
			medium: "#FFDADB",
			weaker: "#FFEFEF",
		},
	},
	highlight: {
		"new-row-bg": "#DDFBF760",
	},
	icon: {
		warning: "#C4781D",
	},
	background: {
		warning: "#ECB14B",
		secondary: "#49536D",
	},
	hyperlink: {
		default: "#4474D7",
		hover: "#4474D7",
	},
};
